<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar
        class="navbar-skelton"
        :class="navbarClasses"
        :style="navbarStyle"
        :color="navbarColor"
      >
        <div slot="title">
          <vs-navbar-title>
            <img src="./ubp.png" height="60" />
          </vs-navbar-title>
        </div>

        <vs-navbar-item id="profile">
          <router-link to="/home">
            <a>Dashboard</a>
          </router-link>
        </vs-navbar-item>
        <vs-navbar-item id="profile">
          <router-link to="/apps">
            <a>Apps</a>
          </router-link>
        </vs-navbar-item>
        <vs-navbar-item v-if="activeRole === 'pegawai'" id="profile">
          <router-link to="/pegawai/profil">
            <span class="ml-2">{{ activeUserInfo }}</span>
          </router-link>
        </vs-navbar-item>
        <vs-navbar-item v-else id="profile">
          <router-link to="/mahasiswa/profil">
            <span class="ml-2">{{ activeUserInfo }}</span>
          </router-link>
        </vs-navbar-item>

        <vs-navbar-item id="profile">
          <a href="javascript:void(0)" @click.prevent="logout">
            <vs-button color="danger" type="filled" class="ml-2">
              Logout
            </vs-button>
          </a>
        </vs-navbar-item>
      </vs-navbar>
    </div>
  </div>
</template>
<script>
import { confirmAndLogout } from "@/utils/logout";

export default {
  name: "the-navbar-horizontal",
  props: {
    navbarType: {
      type: String,
      required: true,
    },
  },

  computed: {
    activeUserInfo() {
      //   return this.$store.state.AppActiveUser;
      return this.$store.state.account.nama;
    },

    activeRole() {
      return this.$store.state.account.role;
    },
    navbarColor() {
      let color = "#fff";
      if (this.navbarType === "sticky") {
        color = "#f7f7f7";
      } else if (this.navbarType === "static") {
        if (this.scrollY < 50) {
          color = "#f7f7f7";
        }
      }

      this.isThemedark === "dark"
        ? color === "#fff"
          ? (color = "#10163a")
          : (color = "#262c49")
        : null;

      return color;
    },

    isThemedark() {
      return this.$store.state.theme;
    },

    navbarStyle() {
      return this.navbarType === "static"
        ? { transition: "all .25s ease-in-out" }
        : {};
    },

    navbarClasses() {
      return this.scrollY > 5 && this.navbarType === "static"
        ? null
        : "d-theme-dark-light-bg shadow-none";
    },

    scrollY() {
      return this.$store.state.scrollY;
    },

    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },

    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  methods: {
    logout() {
      confirmAndLogout(this.$router);
    },
  },
};
</script>
<style scoped>
#profile {
  font-size: 20px;
  color: #111211;
}
</style>

